import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SurveyService } from 'src/app/services/survey/survey.service';
import { Survey } from 'src/app/models/survey/survey';
import { Message } from 'src/app/models/message';

@Component({
  selector: 'app-surveys-list',
  templateUrl: './surveys-list.component.html',
  styleUrls: ['./surveys-list.component.scss']
})
export class SurveysListComponent implements OnInit {

  formAdd: FormGroup;
  surveys: Survey;
  msg: Message = { status: null, message: null };
  hiddenMsg: boolean = true;
  btnAdd: boolean = true;

  survey: Survey = {
    id: 0,
    idcreator: 0,
    idstatus: 3,
    name: '',
    title: 'Encuesta de prueba',
    startdate: null,
    lastaccess: null,
    enddate: null,
    logo: '',
    url: '',
    isOpened: null,
    isComplete: null
  }

  constructor(private surveyService: SurveyService, private fb: FormBuilder, private activedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.createForm();
    this.getAll();
  }

  getAll() {
    this.surveyService.getAll().subscribe(
      res => {
        this.surveys = res['data'];
      },
      err => { this.msg = err; }
    );
  }



  setMessage(msg: string) {
    this.msg.message = msg;
  }

  setStatus(status: number) {
    this.msg.status = status;
  }


  createForm() {
    this.formAdd = this.fb.group({
      id: [null],
      name: ['', [Validators.required]],
      url: [],
      idstatus: [3]
    })
  }


  validateForm() {
    if (this.formAdd.invalid) {
      return Object.values(this.formAdd.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.create(this.formAdd.value);
    }
  }

  create(surv: Survey) {
    delete surv.id;
    const date = new Date();
    surv.url = "encuesta-" + date.getDay() + date.getMonth() + date.getFullYear() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds();
    this.surveyService.create(surv)
      .subscribe(
        res => {
          this.setStatus(res['status']);
          this.setMessage(res['message']);
          this.hiddenMsg = false;
          this.getAll();
          this.btnAdd = !this.btnAdd;
        },
        err => {
          this.setStatus(err["error"].status);
          this.setMessage(err["error"].message);
        }
      )
  }

  remove(id: string) {
    this.surveyService.delete(id).subscribe(
      res => {
        this.setMessage(res['message']);
        this.setStatus(res['status']);
        this.hiddenMsg = false;
        this.getAll();
      },
      err => {
        this.setMessage(err["error"].message);
        this.setStatus(err["error"].status);
      }
    );
  }

  campoNoValido(campo: string) {
    return this.formAdd.get(campo).invalid && this.formAdd.get(campo).touched;
  }


}
